
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component({})
export default class projectCostBudgetSheet extends Vue {
    @Prop({ default: () => [] })
    rows!: Array<any>;
    @Prop({ default: () => [] })
    disabled!: boolean;
    
    forceReload = 0;

    updateLineSum(itemId: any, projectId: any, dailyCost: number, budgetTemplateId: number, lineItem: any, sectionName: any) {
      this.$emit('lineValueChanged', {itemId, projectId, dailyCost, budgetTemplateId, lineItem, sectionName})
    }

    calculateDailyCostTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.dailyCost || 0), 0);
    }

    calculateLineSumTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.lineSum || 0), 0);
    }

    mounted() {
      this.forceReload += 1;
    }
}
